<template>
    <b-form-group 
        :label="label"
        :label-class="finalLabelClass" 
    >
        <b-form-tags
            :value="localValue"
            no-outer-focus
            class="border-0 bg-transparent px-0 shadow-none"
            :tagValidator="isValidEmail"
            @input="handleInput"
        >
            <template v-slot="{ tags, inputAttrs, inputHandlers, addTag, removeTag, disabled, disableAddButton }">
                <b-input-group class="mb-2">
                    <b-form-input
                        v-bind="inputAttrs"
                        v-on="inputHandlers"
                        type="email"
                        :placeholder="placeholder"
                        class="form-control"
                    ></b-form-input>
                    <b-input-group-append>
                        <b-button @click="addTag()" variant="primary" :disabled="disabled || disableAddButton">Add</b-button>
                    </b-input-group-append>
                </b-input-group>
                <div class="d-flex flex-wrap align-items-baseline gap-1" style="">
                    <div
                        v-for="addr in tags"
                        :key="addr"
                        :title="addr"
                        class="d-flex align-items-center gap-1 bg-white-50 border rounded-pill pl-2"
                    >{{ addr }}
                        <b-button @click="removeTag(addr)" variant="minimal-danger" class="p-0 rounded-pill">
                            <b-icon icon="x"></b-icon>
                        </b-button>
                    </div>
                </div>
            </template>
        </b-form-tags>
    </b-form-group>
</template>

<script>
export default {
    name: 'EmailAddressListInput',
    components: {},
    mixins: [],
    props: {
        label: {
            type: String,
            default: 'Email Recipients',
        },
        labelClass: {
            type: String || Array || Object,
            default: '',
        },
        placeholder: {
            type: String,
            default: 'Enter email address and press Enter...',
        },
    },
    data() {
        return {
            localValue: [],
        }
    },
    computed: {
        finalLabelClass() {
            const defaultClass = '';
            if (!this.labelClass) {
                return [defaultClass];
            }
            if (Array.isArray(this.labelClass)) {
                return [...this.labelClass, defaultClass];
            }
            if (typeof this.labelClass === 'object') {
                return { ...this.labelClass, 'group-label': true };
            }
            // If it's a string, just return it with the default class
            if (this.labelClass) {
                return [this.labelClass, defaultClass];
            }
            return [defaultClass];  // final fallback
        },
    },
    created() {
        
    },
    mounted() {
        
    },
    methods: {
        isValidEmail(email) {
            // simple email validation function - make better later....
            const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return re.test(email);
        },
        handleInput(addrList) {
            this.localValue = addrList;
            this.$emit('input', addrList);
        },
    },
}
</script>

<style lang="scss">
</style>